import { Crown, Trophy, Award, Gift, Newspaper, Globe, Star, Footprints } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { HIGHLIGHTS } from "@/lib/site";

const ICONS = { Crown, Trophy, Award, Gift, Newspaper, Globe, Star, Footprints };

export default function Highlights() {
  return (
    <section id="highlights" className="py-28 lg:py-36" data-testid="highlights-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading
          eyebrow="Event Highlights"
          title={<>Everything a Winner <span className="gold-text">Deserves</span></>}
          sub="Eight signature honours await those who step onto the Treasure stage."
          testId="highlights-heading"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 auto-rows-[220px] gap-4" data-testid="highlights-grid">
          {HIGHLIGHTS.map((h, i) => {
            const Icon = ICONS[h.icon];
            return (
              <Reveal key={h.title} delay={0.06 * i}>
                <div
                  className="group h-full glass-card rounded-md p-6 flex flex-col justify-end transition-all duration-500 hover:border-gold/50 hover:shadow-[0_0_35px_rgba(212,175,55,0.12)] hover:-translate-y-1"
                  data-testid={`highlight-card-${i}`}
                >
                  <div className="mb-auto">
                    <div className="w-12 h-12 rounded-full border border-gold/40 flex items-center justify-center transition-all duration-500 group-hover:bg-gold/10 group-hover:shadow-[0_0_20px_rgba(212,175,55,0.3)]">
                      <Icon size={22} className="text-gold" />
                    </div>
                  </div>
                  <h3 className="font-display text-xl text-cream">{h.title}</h3>
                  <p className="mt-1.5 text-muted text-sm">{h.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
